import { render } from "./attribute-common-card.html?vue&type=template&id=7fd412c5&scoped=true&ts=true"
import script from "./attribute-common-card.ts?vue&type=script&lang=ts"
export * from "./attribute-common-card.ts?vue&type=script&lang=ts"

import "./attribute-common-card.scss?vue&type=style&index=0&id=7fd412c5&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd412c5"]])

export default __exports__